<template>
    <form @submit.prevent="handleSubmit(item)" novalidate ref="form">
        <h5>Dłużnik</h5>
        <div class="row">
            <div :class="{ 'form-group col col-md-6': true, 'has-error': (errors && errors.debtorData && errors.debtorData.name) }">
                <label for="_name" class="control-label">Nazwa</label>
                <autocomplete id="_name"
                              ref="name"
                              :classes="{ wrapper: 'form-wrapper', input: 'form-control', list: 'data-list', item: 'data-list-item' }"
                              :onShouldGetData="searchDebtorByName"
                              :onShouldRenderChild="renderAutocompleteItem"
                              :onSelect="autocompleteItemSelected"
                              :debounce="500"
                              :min="3"
                              :onInput="setNameValue"
                              url="test"
                              anchor="name"

                ></autocomplete>
                <span v-if="errors && errors.debtorData && errors.debtorData.name" class="help-block"
                      id="_name_helpBlock">{{ errors.debtorData.name }}</span>
            </div>
            <div :class="{ 'form-group col col-md-6': true, 'has-error': (errors && errors.debtorData && errors.debtorData.nip) }">
                <label for="_nip" class="control-label">NIP</label>
                <autocomplete id="_nip"
                              ref="nip"
                              :classes="{ wrapper: 'form-wrapper', input: 'form-control', list: 'data-list', item: 'data-list-item' }"
                              :onShouldGetData="searchDebtorByNip"
                              :onShouldRenderChild="renderAutocompleteItem"
                              :onSelect="autocompleteItemSelected"
                              :debounce="500"
                              :min="2"
                              :onInput="setNipValue"
                              url="test"
                              anchor="nip"
                ></autocomplete>
                <span v-if="errors && errors.debtorData && errors.debtorData.nip" class="help-block"
                      id="_nip_helpBlock">{{ errors.debtorData.nip }}</span>
            </div>
            <div :class="{ 'form-group col col-md-6': true, 'has-error': (errors && errors.debtorData && errors.debtorData.regon) }">
                <label for="_regon" class="control-label">REGON</label>
                <autocomplete id="_regon"
                              ref="regon"
                              :classes="{ wrapper: 'form-wrapper', input: 'form-control', list: 'data-list', item: 'data-list-item' }"
                              :onShouldGetData="searchDebtorByRegon"
                              :onShouldRenderChild="renderAutocompleteItem"
                              :onSelect="autocompleteItemSelected"
                              :debounce="500"
                              :min="2"
                              :onInput="setRegonValue"
                              url="test"
                              anchor="regon"
                ></autocomplete>
                <span v-if="errors && errors.debtorData && errors.debtorData.regon" class="help-block"
                      id="_regon_helpBlock">{{ errors.debtorData.regon }}</span>
            </div>
            <div class="form-group col col-md-6 has-error has-error">
                <b-form-checkbox id="checkbox1"
                                 v-model="item.debtorData.cessionAvailable">
                    Cesja możliwa
                </b-form-checkbox>
            </div>
            <div :class="{ 'form-group col col-md-4': true, 'has-error': (errors && errors.debtorData && errors.debtorData.address && errors.debtorData.address.street) }">
                <label for="_address_street" class="control-label">Ulica</label>
                <input type="text" placeholder="" v-model="item.debtorData.address.street" id="_address_street"
                       class="form-control"/>
                <span v-if="errors && errors.debtorData && errors.debtorData.address && errors.debtorData.address.street"
                      class="help-block"
                      id="_address_street_helpBlock">{{ errors.debtorData.address.street }}</span>
            </div>
            <div :class="{ 'form-group col col-md-2': true, 'has-error': (errors  && errors.debtorData && errors.debtorData.address && errors.debtorData.address.number) }">
                <label for="_address_number" class="control-label">Numer domu</label>
                <input type="text" placeholder="" v-model="item.debtorData.address.number" id="_address_number"
                       class="form-control"/>
                <span v-if="errors  && errors.debtorData && errors.debtorData.address && errors.debtorData.address.number"
                      class="help-block"
                      id="_address_number_helpBlock">{{ errors.debtorData.address.number }}</span>
            </div>
            <div :class="{ 'form-group col col-md-2': true, 'has-error': (errors  && errors.debtorData && errors.debtorData.address && errors.debtorData.address.postalCode) }">
                <label for="_address_postal_code" class="control-label">Kod pocztowy</label>
                <input type="text" placeholder="" v-model="item.debtorData.address.postalCode" id="_address_postal_code"
                       class="form-control"/>
                <span v-if="errors  && errors.debtorData && errors.debtorData.address && errors.debtorData.address.postalCode"
                      class="help-block"
                      id="_address_postal_code_helpBlock">{{ errors.debtorData.address.postalCode }}</span>
            </div>
            <div :class="{ 'form-group col col-md-4': true, 'has-error': (errors  && errors.debtorData && errors.debtorData.address && errors.debtorData.address.city) }">
                <label for="_address_city" class="control-label">Miasto</label>
                <input type="text" placeholder="" v-model="item.debtorData.address.city" id="_address_city"
                       class="form-control"/>
                <span v-if="errors  && errors.debtorData && errors.debtorData.address && errors.debtorData.address.city"
                      class="help-block"
                      id="_address_city_helpBlock">{{ errors.debtorData.address.city }}</span>
            </div>

            <div :class="{ 'form-group col col-md-12': true, 'has-error': (errors  && errors.debtorData && errors.debtorData.comments) }">
                <label for="_comments" class="control-label">Uwagi</label>
                <input type="text" placeholder="" id="_comments" v-model="item.debtorData.comments"
                       class="form-control full-width"/>
                <span v-if="errors  && errors.debtorData && errors.debtorData.comments" class="help-block"
                      id="_comments_helpBlock">{{ errors.debtorData.comments
                    }}</span>
            </div>
        </div>
        <h5> Dane faktury</h5>
        <div class="row">
            <div :class="{ 'form-group col col-md-6': true, 'has-error': (errors && errors.number) }">
                <label for="_number" class="control-label">Numer faktury</label>
                <input type="text" placeholder="" v-model="item.number" id="_number" class="form-control"/>
                <span v-if="errors && errors.number" class="help-block" id="_number_helpBlock">{{ errors.number
                    }}</span>
            </div>
            <div :class="{ 'form-group col col-md-6': true, 'has-error': (errors && errors.amount) }">
                <label for="_amount" class="control-label">Kwota</label>
                <b-input-group :right="currencyName">
                    <input type="text" v-model="item.amount" placeholder="" id="_amount" class="form-control"/>
                </b-input-group>
                <span v-if="errors && errors.amount" class="help-block" id="_amount_helpBlock">{{ errors.amount
                    }}</span>
            </div>
            <div :class="{ 'form-group col col-md-6': true, 'has-error': (errors && errors.createDate) }">
                <label for="_createDate" class="control-label">Data wystawienia</label>
                <el-date-picker
                        id="_createDate"
                        v-model="item.createDate"
                        type="date"
                        placeholder="">
                </el-date-picker>
                <span v-if="errors && errors.createDate" class="help-block"
                      id="_createDate_helpBlock">{{ errors.createDate }}</span>
            </div>
            <div :class="{ 'form-group col col-md-6': true, 'has-error': (errors && errors.paymentDate) }">
                <label for="_paymentDate" class="control-label">Data płatności</label>
                <el-date-picker
                        id="_paymentDate"
                        v-model="item.paymentDate"
                        type="date"
                        placeholder="">
                </el-date-picker>
                <span v-if="errors && errors.paymentDate" class="help-block"
                      id="_paymentDate_helpBlock">{{ errors.paymentDate }}</span>
            </div>
        </div>
    </form>
</template>

<script>
  import http from './../../utils/http'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      currencyName: {
        type: String,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      }
    },
    data: function () {
      return {
        defaultData: {
          debtorData: {
            name: '',
            nip: '',
            regon: '',
            cessionAvailable: true,
            comments: '',
            address: {
              city: '',
              number: '',
              postalCode: '',
              street: '',
            }
          },
          createDate: '',
          paymentDate: '',
          number: '',
          cessionAvailable: true,
        }
      }
    },
    mounted(){
        this.setValueToAutocmplitedField();
    },
    computed: {
      item: function () {
        return this.initialValues ? this.initialValues : Object.keys(this.values).length > 0 ? this.values : this.defaultData;
      }
    },
    methods: {
      searchDebtorByName: function (value) {
        return http.fetch('/debtors?name=' + value)
          .then(response => response.json())
          .then(data => {
            return data['hydra:member']
          })
      }
      ,
      searchDebtorByNip: function (value) {
        return http.fetch('/debtors?nip=' + value)
          .then(response => response.json())
          .then(data => {
            return data['hydra:member']
          })
      }
      ,
      searchDebtorByRegon: function (value) {
        return http.fetch('/debtors?regon=' + value)
          .then(response => response.json())
          .then(data => {
            return data['hydra:member']
          })
      },
      setRegonValue(value){
        this.item.debtorData.regon = value.replace(/\s\s+/g, ' ').trim()
      },
      setNameValue(value){
        this.item.debtorData.name = value.replace(/\s\s+/g, ' ').trim()
      },
      setNipValue(value){
        this.item.debtorData.nip = value.replace(/\s\s+/g, ' ').trim()
      },
      sendForm(){
        this.handleSubmit(this.item);
      },
      setValueToAutocmplitedField(){
        this.$refs.name.setValue(this.item.debtorData.name)
        this.$refs.nip.setValue(this.item.debtorData.nip)
        this.$refs.regon.setValue(this.item.debtorData.regon)
      },
      autocompleteItemSelected: function (data) {
        this.item.debtorData.name = data.name
        this.item.debtorData.nip = data.nip
        this.item.debtorData.regon = data.regon
        this.item.debtorData.cessionAvailable = data.cessionAvailable
        this.item.debtorData.comments = data.comments
        this.item.debtorData.address.city = data.address.city
        this.item.debtorData.address.number = data.address.number
        this.item.debtorData.address.postalCode = data.address.postalCode
        this.item.debtorData.address.street = data.address.street

        this.setValueToAutocmplitedField();
      },
      renderAutocompleteItem: function (data) {
        let response = data.name
        if (data.nip != undefined && data.nip != '') {
          response += ` NIP ${data.nip}`
        }
        if (data.regon != undefined && data.regon != '') {
          response += ` REGON ${data.regon}`
        }
        return response
      }
    },
    watch: {
      'item': function () {
        this.setValueToAutocmplitedField();
      },
      'item.debtorData.cessionAvailable': function (data) {
        this.item.cessionAvailable = data
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FormFactoredInvoice.vue?a3f780ae